/**
 * The upgrade-prompt store — a framework-agnostic module singleton (same shape
 * as the command registry). The API layer opens it when the backend answers
 * `402 quota_exceeded`; a host component subscribes and renders the shared
 * `UpgradeModal`. Keeping it outside React lets the `api/` interceptor trigger
 * UI without importing React or a feature.
 */
type Listener = () => void;

const listeners = new Set<Listener>();
let open = false;

function emit(): void {
  for (const listener of listeners) listener();
}

/** Open the upgrade prompt (called by the 402 interceptor + plan-gated CTAs). */
export function openUpgradePrompt(): void {
  if (open) return;
  open = true;
  emit();
}

export function closeUpgradePrompt(): void {
  if (!open) return;
  open = false;
  emit();
}

export function isUpgradePromptOpen(): boolean {
  return open;
}

export function subscribeUpgradePrompt(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
